import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { blackShade19 } from "../../../configs/styles/muiThemes";

function OrderAnalysisEmptyCard({ mt }) {
  return (
    <Stack alignItems="center" gap={1} mt={mt || 0}>
      <Box
        component="img"
        src="/./assets/image/order-cart-empty-1.svg"
        sx={{ width: "auto", height: "90px" }}
      />
      <Typography
        fontSize={14}
        fontWeight={600}
        color={blackShade19}
        lineHeight={1.5}
        mb="4px"
      >
        No orders match here
      </Typography>
    </Stack>
  );
}

export default OrderAnalysisEmptyCard;
